import React, { useState, useRef, useContext } from "react";
import { MyContext } from "../../MyContextApi";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpand, faMinimize } from "@fortawesome/free-solid-svg-icons";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";

function FakeNewsDataGrid({ analysisData = [], tableRef }) {
  const { navigationCount, setNavigationCount } = useContext(MyContext);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const tableContainerRef = useRef();
  const [pageSize, setPageSize] = useState(25);

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
    if (!isFullscreen) {
      tableContainerRef.current.requestFullscreen();
    } else if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  };

  const columns = [
    { field: "id", headerName: "S.No", width: 75 },
    // { field: "Site", headerName: "Platform", width: 115 },
    { field: "datetime", headerName: "DateTime", width: 150
    },
    { field: "claim", headerName: "Claim", width: 400 },
    { field: "synopsis", headerName: "Synopsis", width: 400 },
    { field: "final_result", headerName: "Final Result", width: 150 },
    { field: "confidence_level", headerName: "Confidence Level(%)", width: 150,

    },
    { field: "origin", headerName: "Origin", width: 100,
      renderCell: (params) => (
        <a href={params.value} target="_blank" rel="noopener noreferrer">
          {params.value || "N/A"}
        </a>
      )
    }
  ];

  const rows = analysisData.map((data, index) => ({
    id: index + 1,
    ...data,
  }));

  return (
    <Box
      sx={{
        width: isFullscreen ? "100vw" : "auto",
        height: isFullscreen ? "100vh" : 750,
        display: "flex",
        flexDirection: "column",
        justifyContent: "end",
        overflow: "hidden",
        position: "relative",
        zIndex: 0,
        borderRadius: "15px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
      }}
      ref={tableContainerRef}
    >
      <Paper sx={{ height: "100%", width: "AUTO", overflow: "auto" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          pagination
          checkboxSelection
          disableSelectionOnClick
          autoHeight={false}
        />
      </Paper>
      <IconButton
        onClick={toggleFullscreen}
        sx={{ position: "absolute", top: 10, right: 10 }}
      >
        <FontAwesomeIcon icon={isFullscreen ? faMinimize : faExpand} />
      </IconButton>
    </Box>
  );
}

export default FakeNewsDataGrid;